// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rj0JCml12l {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.Rj0JCml12l h4 {
  line-height: 3em;
}
.Rj0JCml12l .PlBFeoT9Rx {
  float: left;
  width: 100%;
}
.Rj0JCml12l .tnYMZ7A8ML {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.Rj0JCml12l .tnYMZ7A8ML:hover {
  cursor: pointer;
}
.Rj0JCml12l .tnYMZ7A8ML:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.N0f5idygY_ .f_qB4A9cU0:focus {
  outline: none;
}
.N0f5idygY_ .f_qB4A9cU0.qI5w0a1kSA.sYVcznTMb2 {
  background: #375A88;
}
.N0f5idygY_ .f_qB4A9cU0.qI5w0a1kSA.sYVcznTMb2 span {
  color: #fff;
}
.N0f5idygY_ .sYVcznTMb2 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.N0f5idygY_ .sYVcznTMb2:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.N0f5idygY_ input {
  height: 38px;
  min-width: 220px;
}
.tnYMZ7A8ML.GDusRYe4V2 {
  background: #410102;
}
.tnYMZ7A8ML.fu2jdT57Ga {
  background: #911318;
}
.tnYMZ7A8ML.WisZB1suBB {
  background: #D8293B;
}
.tnYMZ7A8ML.dT7UR6bV37 {
  background: #F2373C;
}
.tnYMZ7A8ML.Kyh1DDM86F {
  background: #FC4448;
}
.tnYMZ7A8ML.uIgetVxtWo {
  background: #ED535E;
}
.tnYMZ7A8ML.qQwU5Ookey {
  background: #E34926;
}
.tnYMZ7A8ML.WTLf0XPbwX {
  background: #FC562B;
}
.tnYMZ7A8ML.h5WoLuzyAc {
  background: #FC6722;
}
.tnYMZ7A8ML.cMBPXtz11M {
  background: #FD7F24;
}
.tnYMZ7A8ML.rMyC80KnBz {
  background: #FD8D26;
}
.tnYMZ7A8ML.i_bxdR6cLX {
  background: #EC9C3E;
}
.tnYMZ7A8ML.RcD1OqHpdb {
  background: #0e673a;
}
.tnYMZ7A8ML.wQfdE_78i1 {
  background: #208740;
}
.tnYMZ7A8ML.nygjSDxaJe {
  background: #239718;
}
.tnYMZ7A8ML.PC5CvO5Dtx {
  background: #55A84D;
}
.tnYMZ7A8ML.lfOhfJSgc5 {
  background: #4BBE5A;
}
.tnYMZ7A8ML.Zm5X84e3Bd {
  background: #0CCA6A;
}
.tnYMZ7A8ML.AXjW2b7lMa {
  background: #0A3C64;
}
.tnYMZ7A8ML.cZpFDgpfNH {
  background: #0d487a;
}
.tnYMZ7A8ML.IipJyWq0TQ {
  background: #10538d;
}
.tnYMZ7A8ML.kPQ3shI_qQ {
  background: #115A99;
}
.tnYMZ7A8ML.SEFctt7xV_ {
  background: #3387E2;
}
.tnYMZ7A8ML._6Uet0y7oW {
  background: #1BA9CF;
}
.tnYMZ7A8ML.quWUSArXOy {
  background: #d27c02;
}
.tnYMZ7A8ML.GeD_t2W1ev {
  background: #fb9402;
}
.tnYMZ7A8ML.DDO4ahjl1E {
  background: #FD9B30;
}
.tnYMZ7A8ML.jq7h9GE2ir {
  background: #FDBE2D;
}
.tnYMZ7A8ML.W3aMmC2FJp {
  background: #FED831;
}
.tnYMZ7A8ML.RmVOMEE1i8 {
  background: #FFFD38;
}
.tnYMZ7A8ML.TVcNq2Wuuq {
  background: #2D215C;
}
.tnYMZ7A8ML.gmCdAHCmwJ {
  background: #483C83;
}
.tnYMZ7A8ML.vFTPh4TsB9 {
  background: #58518d;
}
.tnYMZ7A8ML.J2eHQKArDV {
  background: #7068A9;
}
.tnYMZ7A8ML.USKAFasiYl {
  background: #7f78b2;
}
.tnYMZ7A8ML.F4PhuQbZ3B {
  background: #8f88bc;
}
.tnYMZ7A8ML.dEMaUSq4rz {
  background: #000;
}
.tnYMZ7A8ML.LiS_PoaslJ {
  background: #282626;
}
.tnYMZ7A8ML.QYdZgq_60N {
  background: #242222;
}
.tnYMZ7A8ML.is9Ri3kfY7 {
  background: #353838;
}
.tnYMZ7A8ML.uzZl36s1OG {
  background: #666;
}
.tnYMZ7A8ML.bfLw4Tp5KV {
  background: #999;
}
.cZRvDg7a1T {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.cZRvDg7a1T .kjXGxl_wx2 {
  display: none;
}
.I1gYl8Yw3q.I1gYl8Yw3q {
  width: auto;
  max-width: 1200px;
}
.I1gYl8Yw3q.I1gYl8Yw3q .i1fFCcCJqL {
  position: relative;
  background-color: #375A87;
}
.I1gYl8Yw3q.I1gYl8Yw3q .i1fFCcCJqL .rKm3gACGm3 ._VN0tv78Po {
  font-size: 20px;
}
.I1gYl8Yw3q.I1gYl8Yw3q .u9mGCXp_TH {
  margin-right: 2px;
  font-size: 20px;
}
.I1gYl8Yw3q.I1gYl8Yw3q .AMXFnJ6a2a {
  margin-right: 2px;
  font-size: 28px !important;
}
.I1gYl8Yw3q.I1gYl8Yw3q .w1neRVGFU6 {
  position: absolute;
  top: 12px;
  right: 18px;
}
.I1gYl8Yw3q {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.I1gYl8Yw3q::-webkit-scrollbar {
  display: none;
}
.kwQxPA7kUd {
  justify-content: end !important;
}
.jyTBTsgJol .qHcbtQ0Qtp {
  padding: 28px 36px 0px;
  width: 100%;
  max-width: 800px;
}
.jyTBTsgJol .h4cyoA1ins {
  line-height: 15px;
  margin-bottom: 12px;
}
.jyTBTsgJol .JqGu6y1Epy {
  min-width: 800px;
  padding: 28px 36px 38px;
  width: 100%;
}
.jyTBTsgJol .mf_NGK3TTO {
  width: 728px;
}
.jyTBTsgJol .uMK9TOMxlG,
.jyTBTsgJol .uMK9TOMxlG {
  background: none;
}
.jyTBTsgJol .uMK9TOMxlG > div:first-child,
.jyTBTsgJol .uMK9TOMxlG > div:first-child {
  font-size: 11px;
  font-style: normal;
  margin-left: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `Rj0JCml12l`,
	"color-row": `PlBFeoT9Rx`,
	"color-tile": `tnYMZ7A8ML`,
	"picker-component": `N0f5idygY_`,
	"picker-element": `f_qB4A9cU0`,
	"active": `qI5w0a1kSA`,
	"btn": `sYVcznTMb2`,
	"red-1": `GDusRYe4V2`,
	"red-2": `fu2jdT57Ga`,
	"red-3": `WisZB1suBB`,
	"red-4": `dT7UR6bV37`,
	"red-5": `Kyh1DDM86F`,
	"red-6": `uIgetVxtWo`,
	"orange-1": `qQwU5Ookey`,
	"orange-2": `WTLf0XPbwX`,
	"orange-3": `h5WoLuzyAc`,
	"orange-4": `cMBPXtz11M`,
	"orange-5": `rMyC80KnBz`,
	"orange-6": `i_bxdR6cLX`,
	"green-1": `RcD1OqHpdb`,
	"green-2": `wQfdE_78i1`,
	"green-3": `nygjSDxaJe`,
	"green-4": `PC5CvO5Dtx`,
	"green-5": `lfOhfJSgc5`,
	"green-6": `Zm5X84e3Bd`,
	"blue-1": `AXjW2b7lMa`,
	"blue-2": `cZpFDgpfNH`,
	"blue-3": `IipJyWq0TQ`,
	"blue-4": `kPQ3shI_qQ`,
	"blue-5": `SEFctt7xV_`,
	"blue-6": `_6Uet0y7oW`,
	"yellow-1": `quWUSArXOy`,
	"yellow-2": `GeD_t2W1ev`,
	"yellow-3": `DDO4ahjl1E`,
	"yellow-4": `jq7h9GE2ir`,
	"yellow-5": `W3aMmC2FJp`,
	"yellow-6": `RmVOMEE1i8`,
	"purple-1": `TVcNq2Wuuq`,
	"purple-2": `gmCdAHCmwJ`,
	"purple-3": `vFTPh4TsB9`,
	"purple-4": `J2eHQKArDV`,
	"purple-5": `USKAFasiYl`,
	"purple-6": `F4PhuQbZ3B`,
	"black-1": `dEMaUSq4rz`,
	"black-2": `LiS_PoaslJ`,
	"black-3": `QYdZgq_60N`,
	"black-4": `is9Ri3kfY7`,
	"black-5": `uzZl36s1OG`,
	"black-6": `bfLw4Tp5KV`,
	"picker-theme": `cZRvDg7a1T`,
	"arrow-regular": `kjXGxl_wx2`,
	"add-locked-user-modal__root": `I1gYl8Yw3q`,
	"modal-header__root": `i1fFCcCJqL`,
	"modal-header__ctn": `rKm3gACGm3`,
	"modal-header__title": `_VN0tv78Po`,
	"modal-header__icon": `u9mGCXp_TH`,
	"modal-header__saveicon": `AMXFnJ6a2a`,
	"modal-header__closeBtn": `w1neRVGFU6`,
	"add-locked-user-modal__footer": `kwQxPA7kUd`,
	"locked-user-select": `jyTBTsgJol`,
	"locker-user-warning": `qHcbtQ0Qtp`,
	"locked-user-select__label": `h4cyoA1ins`,
	"locked-user-select__root": `JqGu6y1Epy`,
	"locked-user-select__menuCtn": `mf_NGK3TTO`,
	"locked-user-select__selectContainer": `uMK9TOMxlG`
};
export default ___CSS_LOADER_EXPORT___;
